import { computed, ref } from "vue"
import { defineStore } from "pinia"
import { OS, osInfos, workspaceTypeInfos } from '@webapp/rd/ResearchDataModel'
import { AuthCodeResponse, LocalTokenApi } from "./LocalTokenApi"
import { useTokenManager } from "./TokenManager"
import { DateTime } from "luxon"
import { useGroupAdminNotifications } from "@webapp/gp/GroupAdminNotifications"

const defaultOS: OS = /Mac/.test(navigator.userAgent) ? 'mac' : 'windows'
export const syncAppClientId = "Cofnxru6I9" // public client id for sync app

export const useSignInStore = defineStore("signInStore", () => {
    const subject = ref("")
    const givenName = ref("")
    const familyName = ref("")
    const address = ref("")
    const isNewUser = ref(false)
    const couponCode = ref("")
    const unusedGrant = ref(0)
    const syncAppAuthCode = ref<AuthCodeResponse>()
    const syncAppAuthCodeUsed = ref(false)

    const tokenManager = useTokenManager()
    const gpNotify = useGroupAdminNotifications()

    async function ensureAuthCodeRequestedAsync() {
        if (!syncAppAuthCode.value || DateTime.utc().valueOf() > syncAppAuthCode.value.expirationDate.valueOf()) {
            const token = await tokenManager.getAccessTokenAsync()
            if (token) {
                syncAppAuthCode.value = await LocalTokenApi.getLocalAuthCodeAsync(token, syncAppClientId)
                syncAppAuthCodeUsed.value = false
            }
        }
    }

    gpNotify.onAuthCodeUsed(args => {
        if (args.clientId == syncAppClientId && args.notificationId == syncAppAuthCode.value?.notificationId) {
            syncAppAuthCodeUsed.value = true
        }
    })

    return {
        subject,
        givenName,
        familyName,
        address,
        isNewUser,
        couponCode,
        unusedGrant,
        syncAppAuthCode,
        syncAppAuthCodeUsed,

        ensureAuthCodeRequestedAsync,
    }
})